// extracted by mini-css-extract-plugin
module.exports = {"header":"header__2Tn5D","title":"title__2uZ3U"};